<template>
  <div class="video-pop-wrap bg-white w-full absolute bottom-0 left-0 flex flex-col items-center">
    <div class="flex-shrink-0 w-full" :class="{ 'wrap-title-shadow': isShadowShow }">
      <slot name="title" />
    </div>
    <div class="wrap-content w-full max-h-full flex flex-col min-h-0">
      <div
        ref="scrollWrap"
        class="pop-content relative flex flex-col w-full max-h-full overflow-y-auto overflow-x-hidden"
        @scroll="throttleScroll"
      >
        <div class="flex-shrink-0">
          <slot></slot>
        </div>
        <div v-if="btnText" class="flex-shrink-0" :class="{ 'btn-wrap': true, shadow: !disabled }">
          <button class="confirm-btn" :disabled="disabled" @click="$emit('clicked')">
            {{ btnText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { throttle } from 'lodash';
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class VideoPopWrap extends Vue {
  @Prop() disabled!: boolean;
  @Prop() btnText!: string;

  isShadowShow = false;

  throttleScroll = throttle(this.handleScroll, 100);

  scrollToBottom() {
    const scroller = this.$refs['scrollWrap'] as HTMLDivElement;

    if (scroller) {
      scroller.scrollTo({
        top: scroller.scrollHeight,
        behavior: 'smooth'
      });
    }
  }

  handleScroll(e: Event) {
    const scrollTop = (e.target as HTMLElement).scrollTop;
    if (typeof scrollTop !== 'number') return;
    if (scrollTop > 0) {
      this.isShadowShow = true;
    } else {
      this.isShadowShow = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.video-pop-wrap {
  max-height: 80%;
  padding-top: 10px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  /* .wrap-content {
    padding-top: 10px;
  } */
  .btn-wrap {
    @apply relative w-full;
    height: 43px;
    margin-top: 20px;
    border-radius: 8px;
  }
  .shadow {
    &::after {
      position: absolute;
      right: 8px;
      bottom: -10px;
      left: 8px;
      height: 20px;
      background: #534fff;
      opacity: 0.3;
      filter: blur(20px);
      content: '';
    }
  }

  button.confirm-btn {
    @apply relative w-full h-full flex justify-center items-center font-medium;
    z-index: 1;
    color: #ffffff;
    font-size: 16px;
    line-height: 24px;
    background: var(--motif-gradient);
    border-radius: 8px;
    &:enabled {
      cursor: pointer;
      &:active {
        opacity: 0.85;
      }
    }

    &:disabled {
      background: #524eff;
      opacity: 0.2;
    }
  }

  .pop-content {
    padding: 0 20px 30px 20px;
  }

  .wrap-title-shadow {
    box-shadow: 0px 2px 8px rgba(43, 52, 57, 0.08);
  }
}
</style>
